import {ThemeVariableType} from '@toolify/client/src/modules/theme/enum/ThemeVariableType'
import {ReadableTextBackgroundColorTypes} from '@toolify/client/src/modules/color/constants/ReadableTextBackgroundColorTypes'

export const ReadableIconBackgroundColorTypes = [
  ...ReadableTextBackgroundColorTypes,
  ThemeVariableType.ContainerHighColor,
  ThemeVariableType.ContainerHighestColor,
] as const
